import CleartripLogo from '@/src/assets/svgs/cleartripLogo'
import FlyinLogo from '@/src/assets/svgs/flyinLogo'
import { CLEARTRIP, FLYIN } from '..'
import { Brand } from '@/src/utils/brand'

const brandLogoConfig = {
    [CLEARTRIP]: CleartripLogo,
    [FLYIN]: FlyinLogo
}

const themeConfig = {
    [CLEARTRIP]: 'B2C',
    [FLYIN]: 'FLYIN'
}

const getBrandLogo = (brand: Brand) => brandLogoConfig[brand] || brandLogoConfig[CLEARTRIP]

const getTheme = (brand: Brand) => themeConfig[brand] || themeConfig[CLEARTRIP]

export { getBrandLogo, getTheme }
